import { Layout } from '@uhg-abyss/web/ui/Layout';
import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import {
  LABELS,
  MODELS,
  OptionsforFileDeatils,
  dSystems,
} from '@src/constants';
import CustomeRowAdd from '../CustomeRowAdd';
import { useSelector } from 'react-redux';
import { getThelistData } from '@src/utils';

const AddFileDetails = () => {
  const dropDownData = useSelector((state) => state?.listOfValues?.data);
  const dsystemSelected = useSelector((state) => state.destinationSystem.data);

  const {
    frequencyCodes,
    channelTypeCodes,
    fileIndicators,
    fileFormatTypes,
    eligibilitySourceTypes,
    destinationSystems,
    feedToVendor,
    vbdMappings,

  } = dropDownData;

  const systemType = getThelistData(destinationSystems, dsystemSelected);
  const isGPSorPRIME =
    systemType === dSystems.GPS || systemType === dSystems.PRIME;
  const isGPS = systemType === dSystems.GPS;
  return (
    <Layout.Group
      css={{
        alignItems: 'start',
        '.abyss-table-cell': {
          paddingTop: '2px',
          paddingBottom: '2px',
        },
      }}
      grow
    >
      <Table.Container title="">
        <Table.TableBody>
          <CustomeRowAdd
            label={LABELS.FILE_FREQUENCY}
            model={'fileDetails.frequencyCode'}
            type={'select'}
            options={frequencyCodes}
          />
          <CustomeRowAdd
            label={LABELS.CHANNEL_TYPE}
            model={'fileDetails.transmitCode'}
            type={'select'}
            options={channelTypeCodes}
          />
          {isGPSorPRIME ? (
            ''
          ) : (
            <CustomeRowAdd
              label={'Feed To Vendor'}
              model={'fileDetails.feedVendor'}
              type={'select'}
              options={feedToVendor}
            />
          )}
          {isGPS && (
            <>
              <CustomeRowAdd
                model={'fileDetails.series800Indicator'}
                label={'800 Series'}
                type={'select'}
                options={OptionsforFileDeatils}
              />
              <CustomeRowAdd
                model={'fileDetails.sapIndicator'}
                label={'SPAP'}
                type={'select'}
                options={OptionsforFileDeatils}
              />
            </>
          )}
        </Table.TableBody>
      </Table.Container>
      <Table.Container title="">
        <Table.TableBody>
          <CustomeRowAdd
            label={LABELS.FILE_INDICATOR}
            model={'fileDetails.fileIndicator'}
            type={'select'}
            options={fileIndicators}
          />
          <CustomeRowAdd
            label={LABELS.NEXT_FILE_EXPECTED_DATE}
            model={'fileDetails.nextFileExpectedDate'}
            type={'date'}
          />
          {isGPS && (
            <CustomeRowAdd
              model={'fileDetails.billGroupIndicator'}
              label={'Bill Group Number Required'}
              type={'select'}
              options={OptionsforFileDeatils}
            />
          )}
        </Table.TableBody>
      </Table.Container>
      <Table.Container title="">
        <Table.TableBody>
          <CustomeRowAdd
            label={LABELS.FILE_FORMAT_CODE}
            model={'fileDetails.fileFormatTypeCode'}
            type={'select'}
            options={fileFormatTypes}
          />
          <CustomeRowAdd
            label={LABELS.ELIGYBILTY_CODE}
            model={'fileDetails.eligibilitySourceType'}
            type={'select'}
            options={eligibilitySourceTypes}
          />
          {isGPSorPRIME ? (
            ''
          ) : (
            <CustomeRowAdd
              label={LABELS.VDB_MAPPING_INDICATOR}
              model={'fileDetails.vbdMappingIndicator'}
              type={'select'}
              options={vbdMappings}
            />
          )}
          {isGPS && (
            <CustomeRowAdd
              label={'Multiple Branches'}
              model={'fileDetails.multiBranchIndicator'}
              type={'select'}
              options={OptionsforFileDeatils}
            />
          )}
        </Table.TableBody>
      </Table.Container>
    </Layout.Group>
  );
};

export default AddFileDetails;
